import api from '../api'

export default {

  stakeholders: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/stakeholders?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

 
  createGetData: async ()=> {
    return api.get('api/stakeholders/create')
  },

  create: async stakeholder => {
    return api.post('api/stakeholders', stakeholder)
  },



  get: async id => {
    return api.get('api/stakeholders/' + id)
  },

  update: async (id,stakeholder) => {
    return api.put('api/stakeholders/' + id, stakeholder)
  },

  delete: async id => {
    return api.delete('api/stakeholders/' + id)
  },

}
